import { render, staticRenderFns } from "./InsertAnalysesData.vue?vue&type=template&id=458823bb&"
import script from "./InsertAnalysesData.vue?vue&type=script&lang=js&"
export * from "./InsertAnalysesData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports